import React from 'react';
import classes from "./styles.module.scss";
import Title from '@/ui/Title';
import Button from '../Button';
import Link from 'next/link';
import Image from "@/ui/Image";
import Plus from "@/assets/Plus.svg";

const ProjectsSectionCard = ({project}) => {
  return <Link className={classes.card} href={`/projects/${project.url_slug}`}>
    <Image img={project.image} size="590x411" alt={project.name} className={classes.image} />
    <div className={classes.overlay}></div>
    <div className={classes.details}>
      <Title title={project.name} className={classes.title} tag="h5" />
      <Plus width={30} height={30} className={`fill tertiary ${classes.icon}`} />
    </div>
  </Link>
}

const ProjectsSection = ({title, projects}) => {
  return <div className={classes.section}>
    <div className={classes.header}>
      <Title title={title} className={`text-white ${classes.title}`} tag="h4" />
      <Button display="VIEW ALL PROJECTS" link="/projects" variant="black" />
    </div>
    <div className={classes.container}>
      {
        projects.map((project, index) => {
          return <ProjectsSectionCard key={index} project={project} />
        })
      }
    </div>
  </div>
}

export default ProjectsSection